<div class="search-widget">
  <div class="d-flex justify-content-between align-items-center">
    <div class="input-group">
      <input class="form-control" type="search" placeholder="Search" aria-label="Search" id="search-bar-input"
        #searchBarInput name="search-input"
        (focus)="openSearchDropdown()"
        (keyup)="onSearchKeywordChange($event)"
        (keyup.enter)="onSearchClicked()"
        [(ngModel)]="searchKeyword" />
      <button class="btn btn-outline-secondary" type="submit" (click)="onSearchClicked()">
        <i class="fa fa-search" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <div class="no-searches" *ngIf="pageHistoryArray.length === 0">
    <span>No recent searches</span>
  </div>

  <div *ngIf="isDropdownOpen && (pageHistoryArray.length > 0)">
    <div class="dropdown-header">
      <span class="title">Recent searches</span>
      <span class="dot"></span>
      <button class="clear-btn" (click)="onClearHistory()" >Clear</button>
    </div>
    <mat-list>
      <mat-list-item *ngFor="let item of pageHistoryArray">
        <mat-icon matListItemIcon>search</mat-icon>
        <span matListItemTitle (click)="onSearchItem(item)">{{ item.deal_name }}</span>
      </mat-list-item>
    </mat-list>
  </div>
</div>